import React from 'react'

import clsx from 'clsx'

import Category from 'components/Category'
import Grid from 'components/Grid'
import { EventContext } from 'context/EventContext'
import { useListingDetailContext } from 'context/ListingDetailContext'

import TextBase from '../TextBase'

/** @type {import("./types").default} */
const RelatedCategories = ({ className }) => {
  const { listing } = useListingDetailContext()
  return (
    <section className={clsx('PopularComparisons', className)}>
      <TextBase title="Related categories" />
      <EventContext value={{ engagementComponent: 'related-categories' }}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {listing.categories.slice(0, 12).map(category => (
                <Grid item key={category.id} xs={12} sm={6} md={4}>
                  <Category.MiniCard category={category} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </EventContext>
    </section>
  )
}

export default RelatedCategories
